var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,16L4,16C4,9.4,9.4,4,16,4c0,0,0,0,0,0c0,0,0,0,0,0C22.3,4,27.4,8.7,28,14.8C27.4,8.7,22.3,4,16,4 C9.4,4,4,9.4,4,16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,16C4,16,4,16,4,16c0,0.4,0,0.7,0,1.1C4,16.7,4,16.4,4,16L4,16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,22.5c-0.1,0.1-0.2,0-0.3-0.1C6.3,20.9,5.6,19,5.4,17c0-0.1,0.1-0.2,0.2-0.2h4c0.1,0,0.2,0.1,0.2,0.2 c0.1,1.4,0.4,2.7,0.8,4c0,0.1,0,0.2-0.1,0.3C9.6,21.6,8.7,22,7.8,22.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,15.1c0,0.1,0.1,0.2,0.2,0.2h4c0.1,0,0.2-0.1,0.2-0.2c0.1-1.4,0.4-2.7,0.8-4c0-0.1,0-0.2-0.1-0.3 c-0.9-0.3-1.8-0.8-2.8-1.2c-0.1-0.1-0.2,0-0.3,0.1C6.3,11.2,5.6,13.1,5.4,15.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,20.7c-0.1,0-0.2,0-0.3-0.1c-0.4-1.2-0.7-2.4-0.7-3.6c0-0.1,0.1-0.2,0.2-0.2h3.7c0.1,0,0.2,0.1,0.2,0.2v3 c0,0.1-0.1,0.2-0.2,0.2C14.2,20.3,13.2,20.4,12.3,20.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,15.1c0,0.1,0.1,0.2,0.2,0.2h3.7c0.1,0,0.2-0.1,0.2-0.2v-3c0-0.1-0.1-0.2-0.2-0.2c-1-0.1-1.9-0.2-2.9-0.5 c-0.1,0-0.2,0-0.3,0.1C11.6,12.7,11.3,13.9,11.2,15.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,20.2c-0.1,0-0.2-0.1-0.2-0.2v-3c0-0.1,0.1-0.2,0.2-0.2h3.7c0.1,0,0.2,0.1,0.2,0.2 c-0.1,1.2-0.3,2.4-0.7,3.6c0,0.1-0.2,0.2-0.3,0.1C18.8,20.4,17.9,20.3,16.9,20.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,15.1c0,0.1,0.1,0.2,0.2,0.2h3.7c0.1,0,0.2-0.1,0.2-0.2c-0.1-1.2-0.3-2.4-0.7-3.6c0-0.1-0.2-0.2-0.3-0.1 c-1,0.3-1.9,0.4-2.9,0.5c-0.1,0-0.2,0.1-0.2,0.2V15.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,21.2c-0.1,0-0.2-0.2-0.1-0.3c0.5-1.3,0.7-2.7,0.8-4c0-0.1,0.1-0.2,0.2-0.2h4c0.1,0,0.2,0.1,0.2,0.2 c-0.2,2-0.9,3.9-2.1,5.5c-0.1,0.1-0.2,0.1-0.3,0.1C23.3,22,22.4,21.6,21.5,21.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.2,15.1c0,0.1,0.1,0.2,0.2,0.2h4c0.1,0,0.2-0.1,0.2-0.2c-0.2-2-0.9-3.9-2.1-5.5c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.9,0.5-1.9,0.9-2.8,1.2c-0.1,0-0.2,0.2-0.1,0.3C21.8,12.4,22.1,13.8,22.2,15.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,25.3c0,0.2,0.2,0.3,0.4,0.2c0.9-1,1.7-2.1,2.3-3.2c0.1-0.1,0-0.3-0.1-0.3c-0.8-0.2-1.5-0.3-2.3-0.4 c-0.1,0-0.2,0.1-0.2,0.2V25.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,10.3c0,0.1,0.1,0.2,0.2,0.2c0.7-0.1,1.5-0.2,2.3-0.4c0.1,0,0.2-0.2,0.1-0.3c-0.6-1.1-1.3-2.2-2.3-3.2 c-0.1-0.1-0.4,0-0.4,0.2V10.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,6.6c0.1-0.1,0.4,0,0.4,0.2v3.5c0,0.1-0.1,0.2-0.2,0.2c-0.7-0.1-1.5-0.2-2.2-0.4c-0.1,0-0.2-0.2-0.1-0.3 C13.3,8.7,14,7.6,15,6.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,21.6c0.1,0,0.2,0.1,0.2,0.2v3.5c0,0.2-0.2,0.3-0.4,0.2c-0.9-1-1.7-2.1-2.2-3.2c-0.1-0.1,0-0.3,0.1-0.3 C13.6,21.8,14.4,21.6,15.1,21.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,5.7c-0.2-0.1-0.4,0.2-0.2,0.4c0.9,1.1,1.7,2.2,2.3,3.4c0.1,0.1,0.2,0.2,0.3,0.1c0.7-0.3,1.5-0.6,2.3-1 c0.1-0.1,0.2-0.3,0.1-0.4C22,7,20.4,6.1,18.6,5.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,22.5c-0.1,0-0.2,0-0.3,0.1c-0.6,1.2-1.3,2.3-2.3,3.4c-0.1,0.2,0,0.4,0.2,0.4c1.8-0.4,3.4-1.3,4.7-2.5 c0.1-0.1,0.1-0.3-0.1-0.4C22.5,23.1,21.7,22.8,21,22.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,23.9c-0.1-0.1-0.1-0.3,0.1-0.4c0.8-0.4,1.5-0.7,2.3-1c0.1,0,0.2,0,0.3,0.1c0.6,1.2,1.3,2.3,2.3,3.4 c0.1,0.2,0,0.4-0.2,0.4C11.7,25.9,10.1,25.1,8.8,23.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,5.7c0.2-0.1,0.4,0.2,0.2,0.4c-0.9,1.1-1.7,2.2-2.3,3.4c-0.1,0.1-0.2,0.2-0.3,0.1c-0.7-0.3-1.5-0.6-2.3-1 C8.7,8.5,8.7,8.3,8.8,8.2C10.1,7,11.7,6.1,13.4,5.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnv);
export default __webpack_public_path__ + "static/media/env.2b41d29ee36a9c3316ee214f2fb6d94d.svg";
export { ForwardRef as ReactComponent };